export default {
    props: {
        moduleName: {
            type:     String,
            required: true,
        },
    },
};
